module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fm-title",
    attrs: {
      "id": "fm-2"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_c('em', [_vm._v("Consulting Editors")])])]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_c('p', {
    staticClass: "fm-para"
  }, [_c('strong', [_vm._v("E"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("STHER")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HAZON")])]), _vm._v(" Hebrew University of Jerusalem, Israel")]), _vm._v(" "), _c('p', {
    staticClass: "fm-para"
  }, [_c('strong', [_vm._v("S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HAYE")]), _vm._v(" J. D. C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OHEN")])]), _vm._v(" Harvard University, Cambridge, Massachusetts")]), _vm._v(" "), _c('p', {
    staticClass: "fm-para"
  }, [_c('strong', [_vm._v("D"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EVORAH")]), _vm._v(" D"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IMANT")])]), _vm._v(" Haifa University, Israel")]), _vm._v(" "), _c('p', {
    staticClass: "fm-para"
  }, [_c('strong', [_vm._v("H"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ANAN")]), _vm._v(" E"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("SHEL")])]), _vm._v("† Bar-Ilan University, Ramat-Gan, Israel")]), _vm._v(" "), _c('p', {
    staticClass: "fm-para"
  }, [_c('strong', [_vm._v("E"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RICH")]), _vm._v(" S. G"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RUEN")])]), _vm._v(" University of California, Berkeley")]), _vm._v(" "), _c('p', {
    staticClass: "fm-para"
  }, [_c('strong', [_vm._v("M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ARTHA")]), _vm._v(" H"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IMMELFARB")])]), _vm._v(" Princeton University, New Jersey")]), _vm._v(" "), _c('p', {
    staticClass: "fm-para"
  }, [_c('strong', [_vm._v("J"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AMES")]), _vm._v(" L. K"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UGEL")])]), _vm._v(" Bar-Ilan University, Ramat-Gan, Israel")]), _vm._v(" "), _c('p', {
    staticClass: "fm-para"
  }, [_c('strong', [_vm._v("H"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("INDY")]), _vm._v(" N"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AJMAN")])]), _vm._v(" University of Toronto, Ontario")]), _vm._v(" "), _c('p', {
    staticClass: "fm-para"
  }, [_c('strong', [_vm._v("G"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EORGE")]), _vm._v(" W. E. N"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ICKELSBURG")])]), _vm._v(" University of Iowa, Iowa City")]), _vm._v(" "), _c('p', {
    staticClass: "fm-para"
  }, [_c('strong', [_vm._v("L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AWRENCE A.")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHIFFMAN")])]), _vm._v(" New York University, New York")]), _vm._v(" "), _c('p', {
    staticClass: "fm-para"
  }, [_c('strong', [_vm._v("M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ICHAEL")]), _vm._v(" E. S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TONE")])]), _vm._v(" Hebrew University of Jerusalem, Israel")]), _vm._v(" "), _c('p', {
    staticClass: "fm-para"
  }, [_c('strong', [_vm._v("J"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AMES")]), _vm._v(" C. V"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ANDERKAM")])]), _vm._v(" University of Notre Dame, Indiana")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75a9c0fa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/007_Consulting_Editors.vue
// module id = 75
// module chunks = 0